import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { Location } from '@angular/common';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';

import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-fellowship-directory',
  templateUrl: './fellowship-directory.component.html',
  styleUrls: ['./fellowship-directory.component.css'],
})
export class FellowshipDirectoryComponent implements OnInit {
  @ViewChild('movieSearchInput', { static: true }) movieSearchInput: ElementRef;

  loading = false;
  objArr = [];
  pageNo;
  pageSize;
  arrList;
  totalItems;
  arr;
  data = [];
  example;
  modalOptions: NgbModalOptions;
  closeResult: string;
  filterData;
  outputfilterData;
  modalReference: NgbModalRef;
  defaultBounds;
  details;

  constructor(
    private modalService: NgbModal,
    private authService: AuthservicesService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.pageSize = environment.pageSize;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.details = JSON.parse(JSON.stringify(params));
    });

    if (Object.keys(this.details).length == 0) {
      this.getClaimList(1);
    } else {
      this.onFilter(1);
    }

    this.arr = environment.arr;
    fromEvent(this.movieSearchInput.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        filter((res) => res.length > 2),

        debounceTime(1000),

        // If previous query is diffent from current
        distinctUntilChanged()

        // subscription for response
      )
      .subscribe((text: string) => {
        this.loading = false;
        this.objArr = [];
        this.pageNo = event;
        let skip = 0;
        let data = {
          skip: skip,
          limit: this.pageSize,
          search: text
        };
        
        this.authService
          .getCommunityClaimList(data)
          .subscribe(
            (res: any) => {
              this.loading = true;
              this.arrList = res.data;
              this.totalItems = res.total;
              this.arrList.forEach((e) => {
                let address = `${e.address.streetAddress},${e.address.city},${
                  e.address.stateName ? e.address.stateName : e.address.state
                },${e.address.country}`;
                this.objArr.push({
                  id: e._id ? e._id : '',
                  name: e.name ? e.name : '',
                  description: e.address.location ? address : '',
                  photo: e.photo ? this.renderImage(e.photo) : '',
                });
              });
            },
            (error) => {
              this.loading = false;
              console.log(error);
            }
          );
      });
  }

  open(content) {
    this.modalService.open(content, { scrollable: true }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getClaimList(event) {
    this.loading = false;
    this.objArr = [];
    this.arrList = [];
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    let data = {
      skip: skip,
      limit: this.pageSize,
      search: ''
    };
    this.authService.getCommunityClaimList(data).subscribe(
      (res: any) => {
        this.loading = true;
        this.arrList = res.data;
        console.log('arrList',this.arrList);
        this.totalItems = res.total;
        this.objArr = this.createArray(this.arrList);
        // this.arrList.forEach((e) => {
        //   let address = `${e.address.streetAddress},${e.address.city},${(e.address.stateName) ? e.address.stateName : e.address.state},${e.address.country}`
        //   this.objArr.push({
        //     id: (e._id) ? e._id : '',
        //     name: (e.name) ? e.name : '',
        //     description: (e.address.location) ? address : '',
        //     photo: (e.photo) ? this.renderImage(e.photo) : ''

        //   })
        // })
      },
      (error) => {
        this.loading = false;
        console.log(error);
      }
    );
  }

  createArray(arr) {
    let obj = [];
    arr.forEach((e) => {
      let address = `${e.address.streetAddress},${e.address.city},${
        e.address.stateName ? e.address.stateName : e.address.state
      },${e.address.country}`;

      obj.push({
        id: e._id ? e._id : '',
        name: e.name ? e.name : '',
        description: e.address.location ? address : '',
        photo: e.photo ? this.renderImage(e.photo) : '',
      });
    });

    return obj;
  }

  getBlockCommunity(id) {
    let swall = this.authService.swal('block');
    swall.then((result) => {
      if (result.value == true) {
        this.authService.blockCommmunity(id).subscribe(
          (res: any) => {
            this.authService.successMessage(res.message, 'success');
            this.getClaimList(this.pageNo);
          },
          (error) => {
            this.authService.successMessage(error.error.message, 'success');
          }
        );
      }
    });
  }

  getReportCommunity(id) {
    this.authService.reportCommunity(id).subscribe(
      (res: any) => {
        this.authService.successMessage(res.message, 'success');
      },

      (error) => {
        this.authService.successMessage(error.error.message, 'error');
      }
    );
  }

  renderImage(data) {
    return this.authService.spilturl(data);
  }

  setPagination(event) {
    if (this.arrList.length != '') {
      this.getClaimList(event);
    } else if (this.filterData.length != '') {
      this.onFilter(event);
    }
  }

  onFilter(event) {
    this.loading = false;
    this.objArr = [];
    this.arrList = [];
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.details['skip'] = skip;
    this.details['limit'] = this.pageSize;
    this.authService.communitySearch(this.details).subscribe(
      (res: any) => {
        this.loading = true;
        this.filterData = res.items;
        this.totalItems = res.total;
        this.objArr = this.createArray(this.filterData);

        this.modalService.dismissAll();
      },

      (error) => {
        this.authService.successMessage(error.error.message, 'error');
        console.log(error);
      }
    );
  }
}
